import React, { Component } from "react";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { HttpStatus, INITIAL_PAGINATION } from "../../../common/Constants";
import { fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import { getDetailStockTableConfig } from "./config";

class InventoryPartStockInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      pagination: INITIAL_PAGINATION,
    };
  }

  componentDidMount() {
    this.fetchDataStock();
  }

  fetchDataStock = async () => {
    const { onTriggerLoading, selectedData, setError } = this.props;
    const trxType = selectedData?.trxType === "trxIn" ? "TRX_IN" : "TRX_OUT";
    const fn = selectedData?.qrCode
      ? "getStockHistoryInventoryPartWithQR"
      : "getStockHistoryInventoryPartNonQR";
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION")[fn],
      menuName: "Inventory Part",
      setError: setError,
      args: {
        date: selectedData?.date,
        paramLocator: selectedData?.locator,
        paramPartCode: selectedData?.partCode,
        transactionType: trxType,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: res.data.data,
      });
    }
  };

  getTableColumns = () => {
    const { selectedData } = this.props;

    return getDetailStockTableConfig({ isQr: selectedData.qrCode });
  };

  render() {
    const { visible, onClickClose, selectedData } = this.props;
    const { dataTable, pagination } = this.state;
    const type = selectedData.trxType === "trxIn" ? "Masuk" : "Keluar";
    const qrTitle = selectedData.qrCode ? "Dengan QR" : "Tanpa QR";
    return (
      <React.Fragment>
        <SimpleModal
          title={`Detail Stock ${type} (${qrTitle})`}
          visible={visible}
          onClickClose={() => onClickClose()}
          content={
            <ModalContainer>
              <div className="grid grid-3x grid-mobile-none gap-20px margin-bottom-20px">
                <div id="grid-1">
                  <SimpleInput
                    id="input_text_kode_variant"
                    name="tglTransaksi"
                    label="Tanggal"
                    readOnly
                    value={selectedData.date}
                  />
                </div>
              </div>
              <SimpleDataTable
                data={dataTable}
                columns={this.getTableColumns()}
                options={{ serverSide: false }}
                rowsPerPage={pagination.limit}
                toCount={pagination.totalData}
                page={pagination.page - 1}
              />
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default InventoryPartStockInfo;
